import { useState } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "", testId = "theme-toggle" }) {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));
  const toggle = () => {
    const next = !light;
    document.documentElement.classList.toggle("light", next);
    localStorage.setItem("theme", next ? "light" : "dark");
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", next ? "#eceef2" : "#2b2f36");
    setLight(next);
    window.dispatchEvent(new Event("theme-changed"));
  };
  return (
    <button onClick={toggle} title={light ? "Anthrazit" : "Hellsilber"} aria-label="Hell/Dunkel wechseln"
      className={`h-9 w-9 grid place-items-center rounded-full text-slate-400 hover:text-white hover:bg-white/10 transition-colors ${className}`} data-testid={testId}>
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
